module.exports = __webpack_public_path__ + "e1d0111bce9bb23e1fb4ddd404f46ccc.jpg";